export { default as ttt } from '@xingternal/ticktricktrack';
export { default as createTrackingHoc } from './src/createTrackingHoc';
export { matchConfigByEnv, matchEnvByHost, PAGEVIEW } from './src/helper';
